var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiecharticonsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 1.27198C4.8342 1.59244 1.25 5.37765 1.25 10C1.25 12.1915 2.055 14.1941 3.38657 15.7295L9.375 9.74112V1.27198ZM10.625 1.27198V9.375H18.728C18.4221 5.04064 14.9594 1.57787 10.625 1.27198ZM18.728 10.625H10.2589L4.27045 16.6134C5.80593 17.945 7.80847 18.75 10 18.75C14.6223 18.75 18.4076 15.1658 18.728 10.625ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C7.23875 20 4.73789 18.88 2.92893 17.0711C1.11997 15.2621 0 12.7613 0 10Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiecharticonsvg);
export default __webpack_public_path__ + "static/media/piecharticonsvg.a1636ed30c248c88ac980a378d9f3a70.svg";
export { ForwardRef as ReactComponent };